export default "/images/d8103b7427ba17d6f337e34359fb10c2.avif";